import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";

export default function GetCreatescore() {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    pan: "",
    password: "",
    gst: "",
    username: "",
    bankName: "",
    accountNumber: "",
    ifsc: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const goNext = () => {
    if (currentStep < 4) setCurrentStep(currentStep + 1);
  };

  const goPrevious = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  return (
    <>
      <ClientNavbar />
      <div
        className="page-content d-flex flex-column align-items-center justify-content-center"
        style={{
          background:
            "linear-gradient(135deg, rgb(240, 253, 253) 0%, rgba(155, 222, 218, 0.73) 50%, rgb(3, 186, 187) 100%)",
        }}
      >
          {/* Application Heading */}
          <h5 className="mb-2">
            Application for,{" "}
            <span className="text-dangerr fw-bold">MADHU SUDHAN TOSHNIWAL</span>
          </h5>
          <p className="text-muted">
            You're just 4-step away from your eligibility check!
          </p>

          {/* Progress Steps */}
          <div className="d-flex justify-content-center align-items-center mb-5">
            {[1, 2, 3, 4].map((step, index) => (
              <React.Fragment key={step}>
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center ${
                    currentStep === step
                      ? "bg-danger text-white"
                      : step < currentStep
                      ? "bg-success text-white"
                      : "border text-muted"
                  }`}
                  style={{
                    width: "40px",
                    height: "40px",
                    fontWeight: "bold",
                    transition: "0.3s",
                  }}
                >
                  {step}
                </div>
                {index !== 3 && (
                  <div
                    style={{
                      width: "60px",
                      height: "2px",
                      backgroundColor:
                        step < currentStep ? "#28a745" : "#43d3ffff",
                      transition: "0.3s",
                    }}
                  ></div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* ======= STEP 1 ======= */}
          {currentStep === 1 && (
            <div
              className="card shadow-sm p-4 text-center"
              style={{ maxWidth: "500px", width: "100%" }}
            >
              <h4 className="fw-bold mb-3">Get Credit Score</h4>
              <p className="text-muted mb-4">
                Don’t know your credit score? Don’t worry, check it out now.
              </p>

              <div className="d-flex justify-content-between align-items-center">
                <button className="btn btn-gps-primary px-5">Back</button>
                <button className="btn btn-gps-primary px-5" onClick={goNext}>
                  Get OTP
                </button>
              </div>

              <div className="mt-4 text-end">
                <button
                  className="btn btn-gps-primary"
                  style={{ fontSize: "16px" }}
                  onClick={goNext}
                >
                  Skip →
                </button>
              </div>
            </div>
          )}

          {/* ======= STEP 2 ======= */}
          {currentStep === 2 && (
            <div
              className="card shadow-sm p-4"
              style={{ maxWidth: "500px", width: "100%" }}
            >
              <h4 className="fw-bold mb-4 text-center">Income Tax Details</h4>

              <div className="mb-3">
                <label className="form-label fw-semibold">PAN Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter PAN Number"
                  name="pan"
                  value={formData.pan}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold">Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter Password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <button className="btn btn-gps-primary px-4" onClick={goPrevious}>
                  Previous
                </button>
                <button className="btn btn-gps-primary px-4" onClick={goNext}>
                  Save & Next
                </button>
              </div>

              <div className="mt-4 text-end">
                <button
                  className="btn btn-gps-primary"
                  style={{ fontSize: "16px" }}
                  onClick={goNext}
                >
                  Skip →
                </button>
              </div>
            </div>
          )}

          {/* ======= STEP 3 ======= */}
          {currentStep === 3 && (
            <div
              className="card shadow-sm p-4"
              style={{ maxWidth: "500px", width: "100%" }}
            >
              <h4 className="fw-bold mb-4 text-center">Business Details</h4>

              <div className="mb-3">
                <label className="form-label fw-semibold">GST Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter GST Number"
                  name="gst"
                  value={formData.gst}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold">User Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter User Name"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mt-4">
                <button className="btn btn-gps-primary px-4" onClick={goPrevious}>
                  Previous
                </button>
                <button className="btn btn-gps-primary px-4" onClick={goNext}>
                  Save & Next
                </button>
              </div>
            </div>
          )}

          {/* ======= STEP 4 ======= */}
          {currentStep === 4 && (
            <div
              className="card shadow-sm p-4"
              style={{ maxWidth: "500px", width: "100%" }}
            >
              <h4 className="fw-bold mb-4 text-center">Bank Details</h4>

              <div className="mb-3">
                <label className="form-label fw-semibold">Select Bank</label>
                <select
                  className="form-select"
                  name="bankName"
                  value={formData.bankName}
                  onChange={handleChange}
                >
                  <option value="">-- Select Bank --</option>
                  <option value="HDFC Bank">HDFC Bank</option>
                  <option value="ICICI Bank">ICICI Bank</option>
                  <option value="State Bank of India">State Bank of India</option>
                  <option value="Axis Bank">Axis Bank</option>
                </select>
              </div>
{/* 
              <div className="mb-3">
                <label className="form-label fw-semibold">Account Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Account Number"
                  name="accountNumber"
                  value={formData.accountNumber}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold">IFSC Code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter IFSC Code"
                  name="ifsc"
                  value={formData.ifsc}
                  onChange={handleChange}
                />
              </div> */}

              <div className="d-flex justify-content-between align-items-center mt-4">
                <button className="btn btn-gps-primary px-4" onClick={goPrevious}>
                  Previous
                </button>
                <button className="btn btn-success px-4">Finish ✅</button>
              </div>
            </div>
          )}
        </div>
    </>
  );
}
